import { useEffect, useState } from 'react';
import { useLazyGetEmissorOrderQuery } from '../services/contractOrdersApi';
import { formatAccrualPeriod } from '../utils/fileNamingUtils';
import { useEmissorFlow } from './useEmissorFlow';
export function useEmissorOrderDetails(orderId) {
    const { emissorContractId, isLoading: isFlowLoading } = useEmissorFlow();
    const contractId = emissorContractId ?? '';
    const shouldFetch = Boolean(contractId) && Boolean(orderId);
    const [trigger] = useLazyGetEmissorOrderQuery();
    const [order, setOrder] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        if (!shouldFetch) {
            return undefined;
        }
        let cancelled = false;
        setOrder(null);
        setIsError(false);
        setIsFetching(true);
        trigger({ contractId, orderId }, false)
            .unwrap()
            .then(result => {
            if (!cancelled) {
                setOrder(result);
                setIsFetching(false);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setIsError(true);
                setIsFetching(false);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [trigger, contractId, orderId, shouldFetch]);
    const details = order
        ? {
            orderId: order.id,
            contractId,
            orderTotalValue: order.totalAmount,
            accrualPeriod: formatAccrualPeriod(order.competenceDate),
            companyName: order.contract?.legalName ?? '',
            orderName: order.description,
            protocol: order.protocol ?? '',
            readableCode: order.payment?.readableCode ?? null,
            paymentMethod: order.payment?.paymentMethod ?? null,
            paymentStatus: order.payment?.status ?? null,
        }
        : null;
    const isResolving = shouldFetch && !isError && !order;
    return {
        details,
        isLoading: isFlowLoading || isResolving || isFetching,
        isError,
    };
}
